/**
 * Extracted from snippets/product-gallery.liquid (inline <script> at line 425).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at snippets/product-gallery.liquid:425) ---
    // Add alt attributes to images inside video elements (browser-generated from poster attribute)
    (function() {
      function addAltToVideoPosters() {
        document.querySelectorAll('video img').forEach(function(img) {
          if (!img.hasAttribute('alt') || img.getAttribute('alt') === '') {
            const video = img.closest('video');
            const videoMedia = img.closest('video-media');
            let altText = 'Video preview';
            
            // Try to get more descriptive alt text from context
            if (videoMedia) {
              const videoTitle = videoMedia.getAttribute('aria-label') || 
                                videoMedia.querySelector('[aria-label]')?.getAttribute('aria-label');
              if (videoTitle) {
                altText = videoTitle + ' preview';
              }
            }
            
            img.setAttribute('alt', altText);
          }
        });
      }
      
      // Run on page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addAltToVideoPosters);
      } else {
        addAltToVideoPosters();
      }
      
      // Use MutationObserver to catch dynamically added videos
      const observer = new MutationObserver(function(mutations) {
        addAltToVideoPosters();
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Also run after delays to catch videos loaded at different times
      setTimeout(addAltToVideoPosters, 100);
      setTimeout(addAltToVideoPosters, 500);
      setTimeout(addAltToVideoPosters, 1000);
    })();
  
